import React from 'react';

const TruncationNotice = ({ label, limit }: { label: string; limit: number }) => (
  <p className="tw-mb-0 tw-mt-3 tw-text-sm tw-text-spa-tertiary">
    Showing the first {limit} {label} that matched — refine your search to see more.
  </p>
);

export default TruncationNotice;
